export default "__VITE_ASSET__Bq834sv3__"